export const useRepositoryController = () => {
  const controller = new AbortController();

  const abortRepository = () => {
    controller.abort();
  };

  return { abortRepository };
};
